module.exports = __webpack_public_path__ + "static/media/cash.ab87f5fe.svg";